import { Input } from '@/ui/Input';

import { Wrapper } from '../shared';

const Widget = ({
	disabled,
	formContext,
	id,
	name,
	onBlur,
	onFocus,
	placeholder,
	readonly,
	value,
}) => {
	const { readonlyAsDisabled = true, schemaProperties } = formContext;

	const handleBlur = ({ target }) => {
		onBlur(id, target.value);
	};
	const handleFocus = ({ target }) => {
		onFocus(id, target.value);
	};

	const mask = schemaProperties[value]?.title ?? value;

	return (
		<Input
			disabled={disabled || (readonlyAsDisabled && readonly)}
			id={id}
			name={name}
			onBlur={!readonly ? handleBlur : undefined}
			// onChange={!readonly ? handleTextChange : undefined}
			onFocus={!readonly ? handleFocus : undefined}
			placeholder={placeholder}
			type="text"
			hint={value}
			value={mask}
		/>
	);
};

const FieldNameWidget = (props) => {
	const { value, onChange } = props;

	return (
		<Wrapper value={value} onChange={onChange}>
			<Widget {...props} />
		</Wrapper>
	)
}

export { FieldNameWidget };
